module.exports = __webpack_public_path__ + "6d4c0664ed445eff83e9dfdb91636bca.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/history/5.jpg
// module id = 270
// module chunks = 0